var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.block ? _c('code', {
    class: _vm.modeClass
  }, [_vm._t("default")], 2) : _c('pre', {
    class: _vm.modeClass
  }, [_vm._v("  "), _vm._t("default"), _vm._v("\n")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };